import { Nullable } from '@/models/Model';
import { LessonBlockRef } from '@/models/ScheduledLesson';

export type ContinuityLesson = {
  lessonId: number;
  name: string;
  order: number;
  bannerImg?: string;
  unitId?: number;
  unitName?: string;
  unitOrder?: number;
  scheduledLessonOrder?: number;
};

export type ContinuityLessonSource = {
  id: number;
  name: string;
  order: number;
  bannerImg?: string;
  lessonBlock?: Nullable<LessonBlockRef>;
};

export const toContinuityLesson = (
  { id, name, order, bannerImg, lessonBlock }: ContinuityLessonSource,
  scheduledLessonOrder?: number,
): ContinuityLesson => ({
  lessonId: id,
  name,
  order,
  bannerImg,
  unitId: lessonBlock?.id,
  unitName: lessonBlock?.name,
  unitOrder: lessonBlock?.order,
  scheduledLessonOrder,
});
